<template>
    <TheLayout>
        <template>
            <router-view />
        </template>
    </TheLayout>
</template>

<script>
    import TheLayout from './layout/TheLayout'
    export default {
        name: 'App',
        components: {
            TheLayout
        },
        mounted() {

        }
    };
</script>